const itemsIonBeta = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  },
  {
    name: 'Perizinan',
    url: '/perizinan',
    icon: 'icon-docs',
    children: [
      {
        name: 'Pengajuan',
        url: '/pengajuan',
        icon: 'icon-doc'
      },
      {
        name: 'Browse',
        url: '/brows',
        icon: 'icon-magnifier'
      }
    ]
  },
  {
    name: 'Upload',
    url: '/upload',
    icon: 'icon-arrow-up-circle ',
    children: [
      {
        name: 'Upload Laporan',
        url: '/pengajuan/upload',
        icon: 'icon-arrow-up-circle '
      },
      {
        name: 'Browse Upload Laporan',
        url: '/pengajuan/browseupload',
        icon: 'icon-magnifier'
      }
    ]
  },
  {
    name: 'Rekonsiliasi Manifes',
    icon: 'icon-size-actual',
    url: '/rekonmanifes',
    children: [
      {
        name: 'Browse',
        url: '/rekonmanifes/browse',
        icon: 'icon-magnifier'
      }
    ]
  },
  {
    name: 'SPPBMCP',
    icon: 'icon-docs',
    children: [
      {
        name: 'Browse SPPBMCP',
        url: '/sppbmcp/listsppbmcp',
        icon: 'icon-magnifier'
      }
    ]
  }
]

const itemsBarpin = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  },
  {
    name: 'PPFTZ Manual',
    url: '/ppftz',
    icon: 'icon-docs',
    children: [
      {
        name: 'Perekaman',
        url: '/ppftz/perekaman',
        icon: 'icon-plus'
      },
      {
        name: 'Browse',
        url: '/ppftz/browse',
        icon: 'icon-magnifier'
      }
    ]
  }
]

const barpin = {
  name: 'PPFTZ Manual',
  url: '/ppftz',
  icon: 'icon-docs',
  children: [
    {
      name: 'Perekaman',
      url: '/ppftz/perekaman',
      icon: 'icon-plus'
    },
    {
      name: 'Browse',
      url: '/ppftz/browse',
      icon: 'icon-magnifier'
    }
  ]
}
export default {itemsIonBeta, itemsBarpin, barpin}



// WEBPACK FOOTER //
// ./src/_nav.js